const state = {
  state: 'closed',
  isClosed: true
};

export default state;
